//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			list: [],
			page: {
				pageSize: 10,
				currentPage: 1,
				sortType: '4',
				count: 0,
				loading: false,
			},
			state: ['', '收入', '支出']
		}
	},
	onLoad() {
		this.queryData()
	},
	onReachBottom() {
		if (this.list.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		// 列表获取
		queryData(status) {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/integrals/integralsdetail/selectByMemberId',
				data: {
					...this.page,
					memberId: this.$store.state.userInfo.memberId
				}
			}).then(res => {
				this.list.push.apply(this.list, res.data.list)
				this.page.loading = false
				this.count = res.data.total
				this.page.currentPage += 1
			})
		},
	}
}
